export default {
    groups: {
        action: "Action",
        actionOptions: "Action Options",
        actionType: "Action Type",
        availChannelsUplink: "Available Uplink Channels / Base Stations",
        availChannelsUplinkOnly: "Available Uplink Channels",
        availChannelsDownlink: "Available Downlink Channels / Base Stations",
        id: "ID",
        rules: 'Rules',
        createRule: "Create Rule",
        updateRule: "Update Rule",
        deleteRule: 'Delete Selected Rule',
        type: "Type",
        groups: "Groups",
        ruleConfig: "Rule Configuration",
        ruleGroupResults: "Group Results",
        group: "Group",
        groupDetails: 'Group Details',
        groupName: 'Group Name',
        ruleInfo: 'Rule Info',
        ruleName: 'Rule Name',
        ruleSuite: 'Rule Set',
        sortGrouping: 'Sort Label',
        ruleGroup: 'Rule Group',
        membershipRules: "Membership Criteria",
        modificationDate: "Rule Modification Date",
        modificationUser: "User",
        order: 'Order',
        totalRadios: 'Total Radios',
        radiosMovingUp: 'Moving Up',
        radiosPerfIncreasing: '(Endpoints Move Up) Performance Increasing',
        radiosMovingDown: 'Moving Down',
        radiosPerfDecreasing: '(Endpoints Move Down) Performance Decreasing',
        radiosMovingIn: 'Moving In',
        radiosMovingOut: 'Moving Out',
        radiosMovingInTotal: 'Moving In Total',
        radiosMovingInMPass: 'Moving In mPass',
        groupItemsContainerTitle: 'Group Items',
        deleteGroupPrompt: 'Are you sure you want to delete group "{ruleName}"?',
        deleteSetPrompt: 'Are you sure you want to delete set "{setName}"?',
        groupSuccess: '{actionType} group success',
        groupFailed: '{actionType} group failed',
        targetConfiguration: "Target Config",
        enableAction: "Enable Action",
        disableAction: "Disable Action",
        actionEnabled: "Action Enabled",
        ruleEnabled: "Rule Enabled",
        enableRule: "Enable Rule",
        nextStartTimeTitle: 'Next Full Tuning Run:',
        radiosAlreadyConfigured: 'Total {totalCount} Already configured',
        matchedMembershipCriteria: 'Total {totalCount} Matched Membership Criteria', 
        disableRule: "Disable Rule",
        actionCurrentlyEnabled: "Action Currently Enabled",
        actionEnabledThisRun: "Action Was Enabled On This Run",
        enableTakeAction: "Enable Group Actions",
        disableTakeAction: "Disable Group Actions",
        autoOptPerf: "Auto Optimize Performance",
        ruleType: "Rule Type",
        description: "Description",
        ruleDescription: "Rule Description",
        executionOrder: 'Execution Order',
        enableActionSuccess: "Action Enabled Successfully",
        disableActionSuccess: "Action Disabled Successfully",
        updateActionFail: "Update Action Failed",
        immediateActionSuccess: "Immediate Action Applied Successfully",
        immediateActionFailed: "Immediate Action Failed",
        ruleNameRequired: "Rule Name Required",
        executionOrderMin: "Execution order must be > 0",
        ruleTypeRequired: "Rule Type Required",
        executionOrderMax: "Max allowed execution order is 999",
        executionOrderReq: "Execution Order Required",
        matchAction: "(Endpoints Matching) Radios Already Configured for this Group",
        matchMembership: "Endpoints Matched Membership for this Group",
        membership: "Membership",
        requiredMembership: 'Required Membership',
        additionalMembership: 'Additional Membership',
        orderedRulesExcludeNote: 'Ordered rules exclude radios from tuning or tunes radios by setting new configuration. Only the first matching rule applies.',
        groupAverageLatencyHours: 'Average Latency',
        groupAverageTransmitRate: 'Average Transmit Rate',
        groupPercentTransmitDirectRadios: 'Average Transmit Rate (% Direct)',
        groupPercentDirectRadiosReadSuccess: 'Read Throughput (% Direct)',
        groupPercentTransmitBuddiedRadios: 'Average Transmit Rate (% Buddied)',
        groupPercentBuddiedRadiosReadSuccess: "Read Throughput (% Buddied)",
        groupPercentTransmitCombined: 'Avg Transmit Rate\n(% Direct/% Buddied)',
        groupPercentCombinedReadSuccess: 'Read Throughput\n(% Direct/% Buddied)',
        actionTypes: {
            NONE: "None",
            NCO_PING_SIMPLE_SETUP: "Ping for Static Setup",
            NCO_SETUP: "Configure"
        },
        ruleTypes: {
            tuning: 'Tuning',
            nonTuning: 'Non Tuning',
            specialConditionRule: 'Special Condition',
            placeholder: 'Placeholder'
        },
        radioTypes: {
            RADIOS_NON_TUNING: "Non Tuning",
            RADIOS_TUNING: "Tuning",
            RADIOS_SPECIAL_CONDITION: "Special Condition",
            RADIOS_PLACEHOLDER: 'Placeholder',
            RADIOS_BUDDY_SB: "Static Rebroadcaster",
            RADIOS_BUDDY_SOS: "SOS Buddy",
            RADIOS_BUDDY_VITAL: "Vital Buddy"
        },
        doNotChange: "Do Not Change",
        enable: "Enabled",
        disable: "Disabled",
        sosBuddy: "SOS Buddy",
        staticRebroadcaster: "Static Rebroadcaster",
        vitalBuddy: "Vital Buddy",
        buddyConfigChangeStartTime: "Buddy Config Change Start Time",
        buddyConfigChangeCount: "Radio Config Changed",
        vitalBuddyConfigChangeId: "Vital Buddy Config Change ID",
        sosBuddyConfigChangeId: "SOS Buddy Config Change ID",
        staticRebroadcasterBuddyConfigChangeId: "Static Rebroadcaster Config Change ID",
        configVitalBuddy: "Configure vital buddies",
        configSOSBuddy: "Configure SOS buddies",
        configSBBuddy: "Configure static rebroadcasters",
        configBuddy: "Configure Buddy",
        updateFailed: "Failed to update rule",
        createFailed: "Failed to create rule",
        requiredMemberFailed:"Failed to create rule \'{name}\' Required membership filter must not be empty",
        additionalMemberFailed:"Failed to create rule \'{name}\' At least one membership criterion must be added",
        deleteFailed: "Failed to delete rule",
        enableActionFailed: "Failed to enable action",
        disableActionFailed: "Failed to disable Action",
        deleteSuccess: "Deleted rule ",
        fetchRulesListFailed: "Failed to get rules list",
        exeOrderToolTip: "Leave empty for special condition rules otherwise set rules execution order",
        ruleInvalidCombination: "A rule's type must be radios special condition if the rules execution order set to empty",
        ruleAlreadyExist: "Rule already exists",
        importedRuleAlreadyExists: 'One or more rules already exist in the rule set they are being imported to',
        executionOrderLimitExceeded: "Maximum execution order limit reached",
        executionOrderPositive: "A tuning group must have an execution order number >= 1",
        ruleCreated: "Created Rule ",
        ruleUpdated: "Updated Rule ",
        cannotBeLowerThanMin: "Min cannot exceed max",
        cannotBeNegative: "Value must be nonnegative",
        ruleSets: 'Rule Sets',
        createRuleSet: 'Create New Rule Set',
        createRuleSetCopy: 'Duplicate Current Rule Set',
        createRuleSetFromSelected: 'Create New Rule Set From Selected Rules',
        deleteRuleSet: 'Delete Current Rule Set',
        setTuningRuleSet: 'Set as Active Tuning Rule Set',
        makeRuleSetInactive: 'Set Rule Set as Inactive',
        setActiveInactiveError: 'Error Setting as Active/Inactive',
        setAlreadyActiveError: "Error Setting as Active. Another Rule Set is Currently Active and Must be Made Inactive.",
        updateRuleSet: 'Edit Rule Set',
        ruleSetLastModified: "Set last modified on {modDate} by {user}",
        activeJob: 'Active: ',
        inactiveJob: 'Inactive',
        readOnly: 'Read Only',
        createRuleSetError: 'Rule Set Creation Failed',
        deleteRuleSetError: 'Rule Set Deletion Failed',
        deleteActiveRuleSetError: 'Before deleting this rule set, you must set it as Inactive.',
        createCopyOfRuleSetError: 'Rule Set Copy Failed',
        invalidRuleSetNameError: 'Rule set names must not be empty or contain invalid characters',
        setName: 'Rule Set Name',
        importRuleSet: 'Import Rule Set from File',
        exportRuleSet: 'Export Rule Set to File',
        import: 'Import',
        ruleSet: "Rule Set",
        runs : "Runs",
        results: "Results",
        invalidJsonFile: "File is not Valid JSON.",
        importRuleSetError: "Error importing rule set.",
        selectRuleSet: "Select Existing Rule Set",
        copyRuleToExisting: "Duplicate Rules to Existing Rule Set",
        copyRuleToCurrent: "Duplicate Rule to Current Rule Set",
        copyRuleToExistingError: "Error Duplicating Rules to Existing Set.",
        copyRuleToCurrentError: "Error Duplicating Rule to Current Set.",
        ruleCreatedWithExecutionOrder: "{name} created with execution order {executionOrder}",
        ruleCreatedNoExecutionOrder: "{name} created",
        duplicateSuffix: ' - duplicate',
        radioConfigTuningNonTuning: 'Tuning and Non-Tuning Rules',
        radioConfigTuning: 'Tuning Rules',
        radioConfigNonTuning: 'Non-Tuning Rules',        
        radioConfigSpecialCondition: 'Special Condition Rules',
        ruleSetActions: {
            CREATE_NEW: 'Create New Rule Set',
            CREATE_COPY: "Duplicate Current Rule Set",
            CREATE_COPY_FROM_SELECTED: "Create New Rule Set from Selected Rules",
            UPDATE: "Edit Rule Set"
        },
        noFiltersActive: 'No filters active',
        filtersActive: 'Filters active',
        tempHints: {
            matchMembership: "The number of endpoints targeted for this group because their performance stats matched this rule’s membership criteria.",
            matchAction: "The number of endpoints currently configured for this group because their configuration already matched the configuration this group’s rule action would set.",
        },
        radioLimit: 'Max Changes',
        initialMessage: 'Please select a JSON file.',
        beginningImport: 'Beginning file import.',
        ruleSetImported: 'Rule set imported successfully',
        ruleSetExists: 'A rule set with this name already exists.',
        ruleSetJSON: 'Rule Set JSON File',
        specialCharCheckFailed: 'Must consist of alphanumeric chars, dashes, spaces, periods, parentheses and underscores',
        jsonInvalid: 'Rule set JSON does not follow schema. See below for errors.'
    }
}
